export default "__VITE_ASSET__Bwi$F_5b__"